import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import PageStructure from 'flarum/forum/components/PageStructure';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import TableView from './BadgeCategoryList/TableView';
import BlockListView from './BadgeCategoryList/BlockListView';
export default class BadgesOverviewPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.bodyClass = 'App--index';
    this.loading = true;
    app.setTitle(app.translator.trans('v17development-flarum-badges.forum.badge.badges'));
    app.store.find('badge-categories').then(() => {
      this.loading = false;
      m.redraw();
    });
  }
  hero() {
    return m("header", {
      className: "Hero BadgesHero"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "containerNarrow"
    }, m("h1", {
      className: "Hero-title"
    }, m("i", {
      "aria-hidden": "true",
      className: "icon fas fa-user-tag"
    }), " ", app.translator.trans('v17development-flarum-badges.forum.badge.badges')))));
  }
  view() {
    const categories = app.store.all('badge-categories').sort((a, b) => a.order() - b.order());
    return m(PageStructure, {
      className: "IndexPage BadgesOverviewPage",
      hero: this.hero.bind(this),
      sidebar: () => m(IndexSidebar, null)
    }, m("h2", {
      className: "BadgeOverviewTitle"
    }, app.translator.trans('v17development-flarum-badges.forum.badge.badges')), this.loading && m(LoadingIndicator, {
      size: "large"
    }), !this.loading && categories.map(category => {
      const badges = (category.badges() || []).sort((a, b) => a.order() - b.order());
      return m("div", {
        className: "BadgeCategory"
      }, m("h3", null, category.name()), category.description() && m("p", null, category.description()), category.isTable() && m(TableView, {
        badges: badges
      }), !category.isTable() && m(BlockListView, {
        badges: badges
      }));
    }));
  }
}
flarum.reg.add('itqan-user-badges', 'forum/components/BadgesOverviewPage', BadgesOverviewPage);